export const breakpoints = {
  breakpoints: {
    values: { xs: 0, sm: 600, md: 980, lg: 1200, xl: 1536 },
  },
};
